module.exports = __webpack_public_path__ + "static/media/Review-Feed.21a98fb8.png";